import { Stack } from "@mantine/core"
import { SectionHeader } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { OrganizationsResponses } from "@tfg/types/endpoints/organizations"

import { CreateDisplaySetting } from "~/pages/Brand/OrganizationSettings/ProductPages/DisplaySettingsCrud/CreateNewDisplaySetting.tsx"
import { OutputCustomizationSettings } from "~/pages/Brand/OrganizationSettings/ProductPages/OutputCustomizationSettings/OutputCustomizationSettings.tsx"
import { ProductSheetsAccess } from "~/pages/Brand/OrganizationSettings/ProductPages/ProductSheetsAccess/ProductSheetsAccess"
import { OrganizationSettingsProvider } from "~/pages/Brand/OrganizationSettings/store/organization-settings-context"
import { useAuth } from "~/store/auth-context"

interface Props {
  organization: Omit<OrganizationsResponses.Organization, "users">
}

export const OrganizationSettingsPage = ({ organization }: Props) => {
  const { t } = useTranslation("organizationSettings")
  const { isAdmin } = useAuth()
  const { agecProductPagePlan } = organization.settings

  return (
    <OrganizationSettingsProvider organization={organization}>
      <Stack>
        <SectionHeader
          title={t("productSheets.title")}
          subtitle={
            agecProductPagePlan === "STARTER"
              ? t("productSheets.starter")
              : agecProductPagePlan === "ESSENTIAL"
                ? t("productSheets.essential")
                : agecProductPagePlan === "ADVANCED"
                  ? t("productSheets.advanced")
                  : undefined
          }
          mainCta={
            isAdmin && (
              <CreateDisplaySetting
                organizationSettingsId={organization.settings.id}
                organizationId={organization.id}
              />
            )
          }
        />
        <ProductSheetsAccess settings={organization.settings} />
        {organization.settings.agecProductPagePlan !== "STARTER" && (
          <OutputCustomizationSettings
            settings={organization.settings}
            isAdmin={isAdmin}
          />
        )}
      </Stack>
    </OrganizationSettingsProvider>
  )
}
